import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from '@/utils/constants'

import { ResetPasswordPayload } from '@/types/auth/resetPassword'

export const askResetPassword = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.ASK_RESET_PASSWORD}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = ResetPasswordPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json()
    },
)
